import React from 'react'
import PropTypes from 'prop-types'
import { CardNumberElement, CardCvcElement, CardExpiryElement } from '@stripe/react-stripe-js'

import TextField from '../FormLegacy/FormFieldsV2/TextField'
import Loader from '../Loader/Loader'

import { stripeElementOptions } from './helpers'

const CreditCardContent = ({
  isLoading,
  isLoadingBuildingCard,
  buildingCreditCard,
  cardOwnerFullName,
  verifyCardDataChanges,
  setBuildingCreditCard,
  setCardOwnerFullName,
}) => {
  if (isLoadingBuildingCard) return <Loader />
  return (
    <div className="credit-card-content card-elements">
      <div className="card-element-label">Credit/debit card number</div>
      <div className={`card-element-wrapper ${isLoading ? 'is-loading-field' : ''}`}>
        <CardNumberElement
          id="card-number-element"
          options={{
            ...stripeElementOptions,
            placeholder: `• • • •  • • • •  • • • •  ${
              buildingCreditCard ? buildingCreditCard.last4 : '• • • •'
            }`,
            disabled: !!buildingCreditCard,
          }}
          onChange={(event) => verifyCardDataChanges(event)}
        />
      </div>
      <div className="flex-row">
        <div className="short-card-element">
          <div className="card-element-label" style={{ top: '-3px' }}>
            Expiration date
          </div>
          <div className={`card-element-wrapper ${isLoading ? 'is-loading-field' : ''}`}>
            <CardExpiryElement
              id="card-expiry-element"
              options={{
                ...stripeElementOptions,
                placeholder: `${buildingCreditCard ? buildingCreditCard.expDate : '(MM/YY)'}`,
                disabled: !!buildingCreditCard,
              }}
              onChange={(event) => verifyCardDataChanges(event)}
            />
          </div>
        </div>
        <div className="short-card-element">
          <div className="card-element-label" style={{ top: '-3px' }}>
            CVV
          </div>
          <div className={`card-element-wrapper ${isLoading ? 'is-loading-field' : ''}`}>
            <CardCvcElement
              id="card-cvc-element"
              options={{
                ...stripeElementOptions,
                placeholder: '• • • •',
                disabled: !!buildingCreditCard,
              }}
              onChange={(event) => verifyCardDataChanges(event)}
            />
          </div>
        </div>
      </div>
      {buildingCreditCard ? (
        <div className="update-card-button" onClick={() => setBuildingCreditCard(null)}>
          Update card info
        </div>
      ) : (
        <React.Fragment>
          <div className="card-element-label">Card holder</div>
          <div className={isLoading ? 'is-loading-field' : ''}>
            <TextField
              name={'cardholderName'}
              placeholder={'First name  Last name'}
              value={cardOwnerFullName}
              onChange={(event) => setCardOwnerFullName(event.target.value)}
            />
          </div>
          <div className="card-elements-info">
            Your card information will be securely saved for convenient future payments. You won't
            need to re-enter your card details for upcoming subscription renewals.
          </div>
        </React.Fragment>
      )}
    </div>
  )
}

CreditCardContent.propTypes = {
  isLoading: PropTypes.bool,
  isLoadingBuildingCard: PropTypes.bool,
  buildingCreditCard: PropTypes.object,
  cardOwnerFullName: PropTypes.string,
  verifyCardDataChanges: PropTypes.func,
  setBuildingCreditCard: PropTypes.func,
  setCardOwnerFullName: PropTypes.func,
}

export default CreditCardContent
